module.exports = __webpack_public_path__ + "static/media/speaker_selected_b.1c8efe0c.svg";